<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('timeCondition') }}</h4>
    <div>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr style="background-color: #F1F5FB">
            <th>{{ $t('timeConditionName') }}</th>
            <th>{{ $t('ext') }}</th>
            <th class="th-80 text-right">
              <span @click="create" class="btn-add"><i class="icon16-plus-circle-gadient"></i></span>
            </th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>{{ item.ext }}</td>
            <td class="text-right">
              <button @click="update(item._id)" class="btn btn-outline-gray btn-sm"
                      type="button">
                <font-awesome-icon icon="info"/>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noTimeConditionFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <b-modal size="lg" v-model="showForm" :title="$t('timeConditionFormTitle')" @ok="save" no-close-on-backdrop
               no-enforce-focus>
        <div class="row">
          <div class="col-md">
            <form-input :label="$t('timeConditionName')" :model="formModel" attribute="name" :errors="formErrors" :placeholder="$t('timeConditionNamePlaceholder')"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('timeConditionExtPlaceholder')"></form-input>
            <time-condition :model="formModel" :errors="formErrors"></time-condition>
            <target-select :label="$t('validTarget')" :model="formModel" attribute="validTarget" :errors="formErrors"></target-select>
            <target-select :label="$t('invalidTarget')" :model="formModel" attribute="invalidTarget" :errors="formErrors"></target-select>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import TargetSelect from "@/components/ClientTargetSelect.vue";
import TimeCondition from './TimeCondition.vue';

export default {
  props: ['client'],
  mixins: [list, crud],
  components: {TimeCondition, TargetSelect},
  data: function () {
    return {
      service: '/time-condition',
      defaultFilterFormModel: {
        client: this.client._id
      },
      autoLoad: true,
    }
  },
  i18n: {
    messages: {
      vi: {
        timeCondition: "Điều kiện thời gian",
        timeConditionName: "Tên",
        timeConditionFormTitle: "Thông tin điều kiện thời gian",
        validTarget: "Đích đến khi thoả mãn điều kiện",
        invalidTarget: "Đích đến khi không thoả mãn điều kiện",
        close: "Đóng",
        noTimeConditionFound: "Chưa có điều kiện thời gian nào được thiết lập",
      },
      en: {
        timeCondition: "Điều kiện thời gian",
        timeConditionName: "Tên",
        timeConditionFormTitle: "Thông tin điều kiện thời gian",
        validTarget: "Đích đến khi thoả mãn điều kiện",
        invalidTarget: "Đích đến khi không thoả mãn điều kiện",
        close: "Đóng",
        noTimeConditionFound: "Chưa có điều kiện thời gian nào được thiết lập",
      }
    }
  }
}
</script>